export const setIsLogged = (logged) => {
  return {
    type: 'SETLOGGED',
    payload: logged,
  }
}
